import {z} from '@hono/zod-openapi';

import {count} from './count';
import {DEAD_STOCK_MAX_OFFSET} from './DEAD_STOCK_MAX_OFFSET';
import {DeadStockBucketSchema} from './DeadStockBucketSchema';
import {DeadStockSortColumnSchema} from './DeadStockSortColumnSchema';
import {identifiers} from './identifiers';

export const DeadStockSnapshotQuerySchema = z
  .object({
    asOf: z.string().date().optional().openapi({example: '2026-09-08'}),
    branch: identifiers,
    warehouse: identifiers,
    manufacturer: identifiers,
    /**
     * Narrows the card page and its count to one age bucket. Server-side rather than in the
     * browser because the page is capped - filtering after the cap would page through the
     * wrong population. The bucket totals are unaffected; they always describe every bucket.
     */
    bucket: DeadStockBucketSchema.optional(),
    /**
     * Ordering is server-side for the same reason: sorting the loaded page would only
     * reorder the rows the user already has, not bring the right ones to the top.
     */
    sortBy: DeadStockSortColumnSchema.optional(),
    sortDirection: z.enum(['asc', 'desc']).optional(),
    /** First row of the page. The caller advances it to append the next page. */
    offset: count.pipe(z.number().max(DEAD_STOCK_MAX_OFFSET)).optional(),
  })
  .openapi('DeadStockSnapshotQuery');

export type DeadStockSnapshotQuery = z.infer<typeof DeadStockSnapshotQuerySchema>;
